// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"AppLoading_loadingScreen__AdNNH"};